module.exports = "/images/Slovakia.png?fa4d72e802c06e62218dfb55c2f06832";